// import ScrollMagic from 'scrollmagic'
import { Datepicker } from 'vanillajs-datepicker';

Datepicker.locales.de = {
  days: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
  daysShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  daysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  months: [
    "Januar", "Februar", "März", "April", "Mai", "Juni",
    "Juli", "August", "September", "Oktober", "November", "Dezember"
  ],
  monthsShort: [
    "Jan", "Feb", "Mär", "Apr", "Mai", "Jun",
    "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"
  ],
  today: "Heute",
  clear: "Löschen",
  format: "dd.mm.yyyy",
  weekStart: 1
};

function eventslistfilter(){
    jQuery.ajax({
                url: main_js_vars.ajax_url,
                type: 'GET',
                data: {
                    action: 'loadposts',
                    event_search: $('#event-search-list').val(),
                    category: $('#event_category').val(),
                    event_date: $('#event_date').attr('data-dateval'),
                    location: $('#location').val(),
                    availability: $('#availability').val(),
                },

                beforeSend: function() {
                    console.log('beforeSend');
                },
                success: function(res) {
//                    if (res) {
			if (!res) res = "<div style=\"padding:100px;\">Keine Events gefunden.</div>";
                        jQuery('.posts.row.events').html(res);
                        lazyLoadInstance.update();
      if (document.getElementById('event-search-list').value) document.getElementById('cancel_input').style.display = '';
      if (document.getElementById('event_category').value) document.getElementById('cancel_category').style.display = '';
      if (document.getElementById('event_date').value) document.getElementById('cancel_date').style.display = '';
      if (document.getElementById('location').value) document.getElementById('cancel_location').style.display = '';
      if (document.getElementById('availability').value) document.getElementById('cancel_availability').style.display = '';

      setAvailabilityLabels();
                    }
//                }
            });
    
}

document.addEventListener('DOMContentLoaded', function() {
    const elemdatepicker = document.querySelector('input#event_date');
    if (elemdatepicker) {
    const datepicker = new Datepicker(elemdatepicker, {
        changeYear: true,
        changeMonth: true,
        changeDate: false,
        autohide: true,
        pickLevel: 1,
        minView: 1,
	language: 'de',
      format: {
            toValue(date, format, locale) {
                return Datepicker.formatDate(date , 'M-yyyy');
            },
            toDisplay(date, format, locale) {
                return Datepicker.formatDate(date , 'M yyyy', 'de');
            },
        },
    });

    // Add an event listener for the 'changeDate' event
    elemdatepicker.addEventListener('changeDate', (event) => {
      // This code will execute whenever the date in the picker changes
      const selectedDate = event.detail.date; // Access the selected date object
      console.log("datechange: eventslist filter form processing");
      console.log(event.target, Datepicker.formatDate(selectedDate , 'M yyyy'));
      event.target.dataset.dateval = Datepicker.formatDate(selectedDate , 'M yyyy');
      eventslistfilter();

      // You can perform further actions here, like updating other elements
      // or sending the date to a server.
    }); 

    }
});

jQuery(document).ready(function($) {
    console.log("eventslist-filter-form");
    const form = document.getElementById('eventslist-filter-form');
    if (form) {
    form.addEventListener('submit', function (e) {
        // Prevent default submit first
        e.preventDefault();
        eventslistfilter();
        console.log("searchinput: eventslist filter form processing");
        return false;
    });

    }


    $('#eventslist-filter-form select,#eventslist-filter-form input:not(#event-search-list)').on( "change", function() {
        console.log("selection: eventslist filter form processing");
      eventslistfilter();
    });




});
